export default {
  header: 'Job Progress',
  jobDetails: 'Job Details',
  viewInManageJobsButton: 'View in Manage Jobs',
  multiDayJob: 'MULTIDAY JOB',
  actionButtons: {
    saveAsTemplate: 'Save as Template',
    addToCalendar: 'Add to Calendar',
  },
  sections: {
    recurrenceTag: {
      longTerm: 'Long term | %shiftName%',
    },
    progressBar: {
      labels: {
        draft: 'Created',
        posted: 'Posted',
        cancelled: 'Cancelled',
        filled: 'Filled',
        inProgress: 'In Progress',
        completed: 'Completed',
        approved: 'Approved',
      },
      descriptions: {
        cancelled: 'You have cancelled this job',
        approved: 'Nice work',
      },
    },
    classification: {
      header: 'Classification',
      type: 'Type',
    },
    generalInformation: {
      header: 'General Information',
      readMore: 'Read More',
      readLess: 'Read Less',
      rowHeaders: {
        id: 'Job ID',
        jobName: 'Job Name',
        summary: 'Job Summary',
        additionalInfo: 'Job Additional Info',
        jobCode: 'Job Code',
        owner: 'Job Owner',
        description: 'Description',
        wonoloersNeeded: 'Wonoloers needed',
        closedPreferred: 'Closed Preferred',
      },
    },
    dressCode: {
      header: 'Clothing Requirements',
      rowHeaders: {
        labels: {
          top: 'Top clothing',
          bottom: 'Bottom clothing',
          footwear: 'Footwear',
          equipment_to_bring: 'Equipment to bring',
          provided_at_venue: 'Provided at location',
          clothing_restriction: 'Clothing restrictions',
          environment: 'Environment expectations',
        },
        emptyDescription: {
          top: 'No preference',
          bottom: 'No preference',
          footwear: 'No preference',
          clothing_restriction: 'None',
          equipment_to_bring: 'None',
          provided_at_venue: 'None',
          environment: 'None',
        },
      },
    },
    where: {
      header: 'Where',
      rowHeaders: {
        venueName: 'Location',
        venueAddress: 'Address',
        venueCity: 'City',
        venueState: 'State',
        venueZip: 'Zip',
        travelTips: 'Travel Tips',
      },
    },
    when: {
      header: 'When',
      rowHeaders: {
        startDate: 'Start Date',
        startTime: 'Start Time',
        estimatedDuration: 'Estimated Duration',
        unpaidBreaks: 'Unpaid Breaks',
        punchWindow: 'Punch Window',
        punchRounding: 'Punch Rounding',
      },
      unpaidBreaks: {
        one: '%numberUnpaidBreaks% Break, %duration%',
        multiple: '%numberUnpaidBreaks% Breaks, %duration% each',
      },
      punchRoundingType: {
        up: 'Up %punchRoundingTime%',
        down: 'Down %punchRoundingTime%',
      },
    },
    pay: {
      header: 'Pay',
      rowHeaders: {
        amount: 'Pay',
      },
    },
    wonoloers: {
      header: 'Wonoloers',
      noWonoloersHeader: 'No Wonoloers',
      noWonoloersContent: 'No Wonoloers here yet',
      columns: {
        name: 'Name',
        status: 'Status',
      },
    },
    requiredBadges: {
      header: 'Required Badges',
      noRequiredBadgesHeader: 'No Badges Required',
      noRequiredBadgesContent: 'No badges required for this job request',
    },
    backgroundChecks: {
      header: 'Background Checks',
    },
  },
  extensionsModal: {
    header: 'Extend job',
    submit: 'Submit extension',
    extensionSuccess: 'Job request successfully extended',
    errors: {
      missingStartDate: 'Please select a start date',
      missingEndDate: 'Please select an end date',
      endDateNotInBounds: 'End date cannot be greater than a year after the start date',
      endDateBeforeStartDate: 'End date cannot be before the start date',
      missingWonoloers: 'Please select at least one wonoloer'
    }
  }
};
